/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import CRMLeadListHeader from "../Header/CRMLeadListHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import ConversationNewMailPopup from "components/Common/Popup/ConversationNewMailPopup";
import AddToListModal from "components/Common/Modal/AddToListModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddAlertModal from "components/Common/Modal/AddAlertModal";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
import LinkedinHelperModal from "components/Common/Modal/LinkedinHelperModal";
import VeriFyEmailModal from "../Modal/VeriFyEmailModal";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AddMultipleLeadsModal from "../Modal/AddMultipleLeadsModal";

import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import LeadAdvFilterPopup from "../Popup/LeadAdvFilterPopup";
import AiRecommendationPopup from "../Popup/AiRecommendationPopup";
import CsvCustomUploadModal from "../Modal/CsvCustomUploadModal";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddCompanyModal from "components/Common/Modal/AddCompanyModal";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import LeadDisablePopup from "../Popup/LeadDisablePopup";
import ScheduleAutomationPopup from "components/Common/Popup/ScheduleAutomationPopup";
import CrmLeadAllowFieldsBySector from "../Popup/CrmLeadAllowFieldsBySector";

const CRMLeadListBody = () => {
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [leadsDataList, setLeadsDataList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  // ✅ only one loading control — when to show skeleton
  const [showSkeleton, setShowSkeleton] = useState(false);

  const [followingLeadsCount, setfollowingLeadsCount] = useState(0);
  const [opportunitiesTotalCount, setopportunitiesTotalCount] = useState(0);
  const [totalNotesCount, settotalNotesCount] = useState(0);
  const [totalConversationCount, settotalConversationCount] = useState(0);

  // default mail subject and content
  const [mailSubject, setMailSubject] = useState("");
  const [mailContent, setMailContent] = useState("");

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [showAllRecords, setShowAllRecords] = useState(false);

  // ✅ CHANGED: null = popup hasn't decided yet (skip API call)
  // []    = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // global search
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [rowSelection, setRowSelection] = useState({});
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedLeadEmails, setSelectedLeadEmails] = useState("");
  const [selectedLeadNames, setSelectedLeadNames] = useState("");

  const [isVerifying, setIsVerifying] = useState(false);

  // Pagination
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // alert
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [enetredNumberForSelect, setEnetredNumberForSelect] = useState("");
  const [selectedNumberValidationMessage, setSelectedNumberValidationMessage] =
    useState("");

  const [showDeleteOffcanvas, setShowDeleteOffcanvas] = useState(false);

  const commonHeaderObject = crmCommonHeaderLinkLists(t);

  // ✅ helper — calculate stats
  const calculateStats = (data) => {
    const followingLeads = data.filter((lead) =>
      lead.followers.includes(userInfo._id),
    );
    setfollowingLeadsCount(followingLeads.length);

    const getSumOfOpportunities = data.reduce(
      (acc, curr) => acc + curr.opportunitycount,
      0,
    );
    setopportunitiesTotalCount(getSumOfOpportunities);

    const getSumOfNotes = data.reduce((acc, curr) => acc + curr.notecount, 0);
    settotalNotesCount(getSumOfNotes);

    const getSumOfConversations = data.reduce(
      (acc, curr) => acc + curr.conversationcount,
      0,
    );
    settotalConversationCount(getSumOfConversations);
  };

  // ✅ CHANGED: withSkeleton param controls skeleton visibility
  // true  = initial load or reset → show skeleton
  // false = search typing        → no skeleton, table stays visible
  const getAllLeads = async (
    isFilter,
    searchTerm = "",
    withSkeleton = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_LEADS;

      requestUrl += `&isfilter=${isFilter}`;

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("request url in get all leads", requestUrl);

      const response = await getData(requestUrl);

      console.log("Response from getAllLeads:", response); // Debug log for API response

      if (response.status) {
        setMessageType("success");
        setLeadsDataList(response.data);
        setIsDataReady(true);
        calculateStats(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setShowSkeleton(false); // ✅ skeleton close
      setIsDataReady(true);
    }
  };

  // ✅ CHANGED: withSkeleton param controls skeleton visibility
  // true  = initial load or filter apply/reset → show skeleton
  // false = search typing or search reset      → no skeleton, table stays visible
  const getLeadsByFilter = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_ADV_FILTER_ALL_LEADS +
        `?roleslug=${userInfo.role ? userInfo.role?.slug : ""}`;

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","),
          };
        }
        return filter;
      });

      const filterData = { filters: sanitizedQuery };

      console.log("Request URL in filterleads:", requestUrl);

      const response = await postData(requestUrl, filterData);

      if (response.status) {
        setMessageType("success");
        setLeadsDataList(response.data);
        calculateStats(response.data);
      } else {
        setMessageType("error");
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowSkeleton(false); // ✅ skeleton close
      setIsDataReady(true);
    }
  };

  // delete bulk leads
  const deleteBulkLeadHandler = async () => {
    if (selectedLeadIds.length > 0) {
      try {
        const leadListToBeDelete = leadsDataList.filter((item) =>
          selectedLeadIds.includes(item._id),
        );

        let apiData = { leadlist: leadListToBeDelete };

        let requestUrl =
          url.API_BASE_URL + url.API_DELETE_BULK_LEAD;

        const response = await putData(requestUrl, apiData);

        if (response.status) {
          setMessageType("success");
          setLeadsDataList(
            leadsDataList.filter((item) => !selectedLeadIds.includes(item._id)),
          );
          setRowSelection({});
          setSelectedLeadIds([]);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage(t("Please select at least one lead"));
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // verify emails
  const emailVerificationHandler = async () => {
    if (selectedLeadIds.length > 0) {
      setIsVerifying(true);
      try {
        let leadData = { leadids: selectedLeadIds };

        let requestUrl =
          url.API_BASE_URL + url.API_VERIFY_LEAD_EMAILS;

        const response = await postData(requestUrl, leadData);
        setIsVerifying(false);

        let myModal = document.querySelector("#veriFyEmail");
        let modal = bootstrap.Modal.getInstance(myModal);
        modal.hide();

        if (response.status) {
          setSelectedLeadIds([]);
          setRowSelection({});
          setMessageType("success");
          setTimeout(() => {
            setLeadsDataList((prev) => updateListByIds(prev, response.data));
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage(t("Please select at least one lead"));
    }
    setShowAlert(true);
  };

  // change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedLeadList = [...leadsDataList];
    const rowIndex = updatedLeadList.findIndex(
      (lead) => lead._id === row.original._id,
    );
    if (rowIndex !== -1) {
      updatedLeadList[rowIndex].rank = value;
      setLeadsDataList(updatedLeadList);
    }
  };

  // update bulk leads
  const updateBulkLeadHandler = async () => {
    if (selectedLeadIds.length > 0) {
      try {
        const leadListToBeUpdate = leadsDataList.filter((item) =>
          selectedLeadIds.includes(item._id),
        );

        let leadData = { leadlist: leadListToBeUpdate };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_MASSIVE_LEAD;

        const response = await putData(requestURL, leadData);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setLeadsDataList((prev) => updateListByIds(prev, response.data));
            setSelectedLeadIds([]);
            setRowSelection({});
          }, 2000);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one course");
    }
    setShowAlert(true);
  };

  // remove tag from lead
  const removeTagFromLead = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_LEAD;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);
      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedLeadId(null);
      }, 1000);
    }
  };

  const handleCloseAddLeadsModal = (data = []) => {
    if (data.length > 0) {
      setLeadsDataList((prevLeads) => [...data, ...prevLeads]);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setLeadsDataList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  // table columns
  const initialTableColumns = [
    {
      accessorKey: "customid",
      header: t("Id"),
      size: 100,
    },
    {
      accessorKey: "tagnames",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tags.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tags.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedLeadId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromLead([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedLeadId &&
                        selectedLeadId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedLeadIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "name",
      header: t("Name"),
      size: 200,
    },
    {
      accessorKey: "surname",
      header: t("Surname"),
      size: 200,
    },
    {
      accessorKey: "rank",
      header: t("Rank"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {row.original.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ? (
            <input
              type="number"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "100px" }}
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="ps-3">{row.original.rank}</p>
          )}
        </div>
      ),
    },
    {
      accessorKey: "email",
      header: t("Email"),
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            width: "250px",
          }}
        >
          <span>{renderedCellValue}</span>
          {row.original.emailverified ? (
            <span className="d-block text-success material-symbols-outlined icon-sm">
              verified
            </span>
          ) : (
            <span className="d-block text-danger material-symbols-outlined icon-sm">
              verified_off
            </span>
          )}
        </Box>
      ),
    },
    {
      accessorKey: "linktrackerstring",
      header: t("Link Tracker"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div
            className={
              row.original.linktrackers && row.original.linktrackers.length > 0
                ? "label-container flex-grow-1"
                : "d-none"
            }
          >
            <ul
              className="d-flex flex-wrap gap-2 m-0 p-0"
              style={{ listStyle: "none" }}
            >
              {row.original.linktrackers &&
                row.original.linktrackers.map((tracker, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium">
                        {tracker}
                      </span>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "subscribetomail",
      header: t("Subscribe to Mail"),
    },
    {
      accessorKey: "ownername",
      header: t("Owner"),
      size: 200,
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          <p>
            <span className="d-block">{row.original.ownername}</span>
          </p>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.ownerid,
                "MOD_LEAD",
                row.original._id,
                row.original.name + " " + row.original.surname,
              );
            }}
            className={
              row.original.ownerid === userInfo._id
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    {
      accessorKey: "followersnames",
      header: t("Followers"),
      size: 200,
      Cell: ({ row }) =>
        row.original.followerslist &&
        row.original.followerslist.map((follower, index) => (
          <div className="owner border-bottom-0 d-flex gap-1 mb-1" key={index}>
            <p>
              <span className="d-block">{follower.follwername}</span>
            </p>
            <button
              onClick={() => {
                createContactChatHandler(
                  follower._id,
                  "MOD_LEAD",
                  row.original._id,
                  row.original.name + " " + row.original.surname,
                );
              }}
              className={
                follower._id === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        )),
    },
    { accessorKey: "source", header: t("Source"), size: 250 },
    { accessorKey: "position", header: t("Position"), size: 200 },
    { accessorKey: "company", header: t("Company"), size: 250 },
    { accessorKey: "phone", header: t("Phone") },
    { accessorKey: "skillsnames", header: t("Skills") },
    { accessorKey: "location", header: t("Location") },
    { accessorKey: "hobbiesnames", header: t("Hobbies") },
    { accessorKey: "leadlastcontactdate", header: t("Last Contact Date") },
    { accessorKey: "lastcontactsubject", header: t("Last Contact Subject") },
    { accessorKey: "lastcontactchannel", header: t("Last Contact Channel") },
    { accessorKey: "leadlastresponsedate", header: t("Last Response Date") },
    { accessorKey: "lastresponsesubject", header: t("Last Response Subject") },
    { accessorKey: "lastresponsechannel", header: t("Last Response Channel") },
    { accessorKey: "transactionid", header: t("Last Transaction") },
    { accessorKey: "module", header: t("Transaction Mod.") },
    { accessorKey: "element", header: t("Trans. Element") },
    { accessorKey: "transactionamount", header: t("Trans. Amt.") },
    { accessorKey: "leadtransactiondate", header: t("Trans. Date") },
    { accessorKey: "leadcreateddate", header: t("Date") },
  ];

  const columns = useMemo(
    () => initialTableColumns,
    [leadsDataList, selectedTagId, i18n.language],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  const initialColumnOrder = [
    "mrt-row-actions",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  // manual row selection by number
  const recordSelectionHandler = () => {
    if (enetredNumberForSelect !== "" || enetredNumberForSelect > 0) {
      if (enetredNumberForSelect <= leadsDataList.length) {
        const getLeadRows = leadsDataList
          .slice(0, enetredNumberForSelect)
          .map((row) => {
            return `${row._id}/${row.email}/${row.ownerid}/${row.fullname}`;
          });

        const selectedResult = {};
        getLeadRows.forEach((item) => {
          selectedResult[item] = true;
        });
        setRowSelection(selectedResult);
      } else {
        setSelectedNumberValidationMessage(
          t("Input number should not be greater than the number of leads"),
        );
      }
    } else {
      setSelectedNumberValidationMessage(
        t("Please enter a valid input number"),
      );
    }
  };

  // row selection effect
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      const selectedLeadIdArr = selectedIdsArray.map((id) => {
        const [leadId] = id.split("/");
        return leadId;
      });

      const selectLeadEmails = selectedIdsArray.map((id) => {
        const [, leadMail] = id.split("/");
        return leadMail;
      });

      setSelectedLeadIds(selectedLeadIdArr);
      setSelectedLeadEmails(selectLeadEmails.join(","));

      if (selectedIdsArray.length === 1) {
        const [, , , leadName] = selectedIdsArray[0].split("/");
        setSelectedLeadNames(leadName);
      } else {
        setSelectedLeadNames("");
      }
    } else {
      setSelectedLeadIds([]);
      setSelectedLeadEmails("");
    }
  }, [rowSelection]);

  // ✅ reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedLeadIds([]);
    setSelectedLeadEmails("");
    setGlobalSearch("");
    setDebouncedSearch("");
    setEnetredNumberForSelect("");
    setSelectedNumberValidationMessage("");
    setShowAllRecords(false); // ✅ reset show-all mode
    setJsonFilterQuery(null); // ✅ null not [] — triggers fetch all
    setReloadData(true);
    setPagination({ pageIndex: 0, pageSize: 10 });
    setLastPagination({ pageIndex: 0, pageSize: 10 });
  };

  const afterEmailClose = () => {
    setRowSelection({});
    setSelectedLeadIds([]);
    setSelectedLeadEmails("");
    setSelectedLeadNames("");
  };

  // ✅ CHANGED: Single API trigger — fires only after popup has decided.
  // null guard prevents API call before popup responds.
  // withSkeleton=true — filter apply always shows skeleton.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery?.length > 0) {
      getLeadsByFilter(debouncedSearch, true);
    } else {
      getAllLeads(false, debouncedSearch, true);
    }
  }, [jsonFilterQuery]);

  // ✅ CHANGED: Search effect — no skeleton (table stays visible).
  // isDataReady guard prevents running before initial load finishes.
  // Priority: showAllRecords > jsonFilterQuery > default
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load

    if (showAllRecords) {
      getAllLeads(true, debouncedSearch, false); // ✅ show all records + debounce search
    } else if (jsonFilterQuery?.length > 0) {
      getLeadsByFilter(debouncedSearch, false); // withSkeleton=false
    } else {
      getAllLeads(false, debouncedSearch, false); // withSkeleton=false
    }
  }, [debouncedSearch]);

  // ✅ reload happened — always show skeleton
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllLeads(false, "", true); // withSkeleton=true
      setReloadData(false);
    }
  }, [reloadData]);

  const refreshRecords = () => {
    setShowAllRecords(false);
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  // save last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // download as excel
  const downloadAsExcel = () => {
    if (leadsDataList.length > 0) {
      // Determine which leads to download
      const leadsToDownload =
        selectedLeadIds.length > 0
          ? leadsDataList.filter((item) => selectedLeadIds.includes(item._id))
          : leadsDataList;

      // Define headers based on MRT columns
      const headers = [
        t("Id"),
        t("Label"),
        t("Name"),
        t("Surname"),
        t("Rank"),
        t("Email"),
        t("Link Tracker"),
        t("Subscribe to Mail"),
        t("Owner"),
        t("Followers"),
        t("Source"),
        t("Position"),
        t("Company"),
        t("Phone"),
        t("Skills"),
        t("Location"),
        t("Hobbies"),
        t("Last Contact Date"),
        t("Last Contact Subject"),
        t("Last Contact Channel"),
        t("Last Response Date"),
        t("Last Response Subject"),
        t("Last Response Channel"),
        t("Last Transaction"),
        t("Transaction Mod."),
        t("Trans. Element"),
        t("Trans. Amt."),
        t("Trans. Date"),
        t("Date"),
      ];

      // Helper to create row data in the same order as headers
      const createRowData = (apiData) => [
        apiData.customid || "",
        (apiData.tags || []).map((tag) => tag.title).join(", "),
        apiData.name || "",
        apiData.surname || "",
        apiData.rank || "",
        apiData.email || "",
        (apiData.linktrackers || []).join(", "),
        apiData.subscribetomail || "",
        apiData.ownername || "",
        (apiData.followerslist || []).map((f) => f.follwername).join(", "),
        apiData.source || "",
        apiData.position || "",
        apiData.company || "",
        apiData.phone || "",
        apiData.skillsnames || "",
        apiData.location || "",
        apiData.hobbiesnames || "",
        apiData.leadlastcontactdate || "",
        apiData.lastcontactsubject || "",
        apiData.lastcontactchannel || "",
        apiData.leadlastresponsedate || "",
        apiData.lastresponsesubject || "",
        apiData.lastresponsechannel || "",
        apiData.transactionid || "",
        apiData.module || "",
        apiData.element || "",
        apiData.transactionamount || "",
        apiData.leadtransactiondate || "",
        apiData.leadcreateddate || "",
      ];

      // Map the lead data to the headers
      const data = leadsToDownload.map(createRowData);

      // Create worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Leads"));

      // Write to buffer
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      // Create blob and save
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Leads")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  const [showAiRecommendation, setShowAiRecommendation] = useState(false);

  // ✅ Debounce — after typing 600ms, setDebouncedSearch will be called
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  const afterDeleteLeads = (deletedLeadIds) => {
    const updatedLeads = leadsDataList.filter(
      (lead) => !deletedLeadIds.includes(lead._id),
    );
    setLeadsDataList(updatedLeads);
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Leads")}
          />
          <div className="container-fluid px-lg-5">
            <CRMLeadListHeader
              userInfo={userInfo}
              reloadLeadList={refreshRecords}
              downloadAsExcel={downloadAsExcel}
              enetredNumberForSelect={enetredNumberForSelect}
              setEnetredNumberForSelect={setEnetredNumberForSelect}
              setSelectedNumberValidationMessage={
                setSelectedNumberValidationMessage
              }
              recordSelectionHandler={recordSelectionHandler}
              selectedNumberValidationMessage={selectedNumberValidationMessage}
              bulkUpdateHandler={updateBulkLeadHandler}
              leadsDataList={leadsDataList}
              followingLeadsCount={followingLeadsCount}
              opportunitiesTotalCount={opportunitiesTotalCount}
              totalNotesCount={totalNotesCount}
              totalConversationCount={totalConversationCount}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedLeadIds={selectedLeadIds}
              onShowAiRecommendation={() => setShowAiRecommendation(true)}
              showAllLeadsHandler={() => {
                setShowAllRecords(true);
                getAllLeads(true, debouncedSearch, true);
              }}
              setShowDeleteOffcanvas={setShowDeleteOffcanvas}
            />

            {/* ✅ Skeleton condition:
              - On first load: isDataReady = false → show skeleton
              - On filter apply/reset: showSkeleton = true → show skeleton
              - While typing in global search: showSkeleton = false → show table
              - On global search close: showSkeleton = false → show table
            */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={leadsDataList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) =>
                    `${row._id}/${row.email}/${row.ownerid}/${row.fullname}`
                  }
                  onRowSelectionChange={setRowSelection}
                  state={{
                    // ✅ If globalSearch exists, use value; otherwise undefined
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  autoResetPageIndex={false}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  renderRowActionMenuItems={({ row }) => {
                    const [leadId, emailId, ownerId, leadName] =
                      row.id.split("/");
                    const menuItems = [];
                    const isAdmin = ["ADMIN", "SUPER_ADMIN"].includes(
                      userInfo.role.slug,
                    );
                    const isOwner =
                      userInfo._id.toString() === ownerId.toString();
                    const hasCrmAccess = moduleAccess.includes("MOD_CRM");
                    const hasOpportunityAccess =
                      moduleAccess.includes("MOD_OPPORTUNITY");

                    if (isAdmin || isOwner) {
                      menuItems.push(
                        <MenuItem key="update">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/save/${leadId}`}
                          >
                            {t("Update Lead")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    menuItems.push(
                      <MenuItem key="details">
                        <Link
                          className="dropdown-item"
                          to={`/admin/crm/lead/information/${leadId}`}
                        >
                          {t("View Details")}
                        </Link>
                      </MenuItem>,
                    );

                    if (isAdmin || isOwner || hasCrmAccess) {
                      menuItems.push(
                        <MenuItem key="leadtask">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/addtask/${leadId}`}
                          >
                            {t("View Task")}
                          </Link>
                        </MenuItem>,
                        <MenuItem key="leadmail">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/communication/recieved/${leadId}`}
                          >
                            {t("View Communication")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    if (isAdmin || (hasCrmAccess && hasOpportunityAccess)) {
                      menuItems.push(
                        <MenuItem key="leadopportunity">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/opportunities/${leadId}`}
                          >
                            {t("View Opportunities")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    if (isAdmin || hasCrmAccess) {
                      menuItems.push(
                        <MenuItem key="leadtimeline">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/timeline/${leadId}`}
                          >
                            {t("View Timeline")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    if (isAdmin || isOwner) {
                      menuItems.push(
                        <MenuItem key="addtochallenge">
                          <Link
                            className="dropdown-item"
                            to={`/admin/crm/lead/addtochallenge/${leadId}`}
                          >
                            {t("Add To Challenge")}
                          </Link>
                        </MenuItem>,
                      );
                    }

                    return menuItems;
                  }}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                  // ✅ MRT will not filter, API will filter
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
          </div>

          <LeadAdvFilterPopup
            moduleSlug="leadlist"
            visibleColoumns={visibleColoumns}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            columns={columns}
          />

          <AddLabelModal
            selectedIds={selectedLeadIds}
            moduleName="crmleadlist"
            afterTagModalClose={afterModalActionClose}
            onModalClose={() => {
              setSelectedLeadIds([]);
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
              setRowSelection({});
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            moduleSlug="MOD_LEAD"
          />

          <ConversationNewMailPopup
            contactPersonEmail={selectedLeadEmails}
            reloadList={afterEmailClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            moduleSlug="MOD_LEAD"
            subject={mailSubject}
            content={mailContent}
            allowSmtpSelection={true}
          />

          <AddToListModal
            moduleName="lead"
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            selectedIds={selectedLeadIds}
            afterModalClose={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
          />

          <AddFollowerModal
            moduleName="crmleadlist"
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            selectedIds={selectedLeadIds}
            afterModalClose={afterModalActionClose}
            onModalClose={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
          />

          <VeriFyEmailModal
            isVerifying={isVerifying}
            onVeriFy={emailVerificationHandler}
            onCancelVeriFy={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
          />

          <AddAlertModal
            selectedIds={selectedLeadIds}
            alertSubject={selectedLeadNames}
            afterModalClose={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
            moduleName={"lead"}
          />

          <LinkedinHelperModal />

          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedLeadIds([]);
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
            onDelete={deleteBulkLeadHandler}
            moduleName={t("lead")}
          />

          <CsvCustomUploadModal afterModalClose={handleCloseAddLeadsModal} />

          <AddMultipleLeadsModal handleClose={handleCloseAddLeadsModal} />

          <AiRecommendationPopup
            selectedLeadIds={selectedLeadIds}
            selectedLeadEmails={selectedLeadEmails}
            setSelectedLeadEmails={setSelectedLeadEmails}
            subject={mailSubject}
            setSubject={setMailSubject}
            content={mailContent}
            setContent={setMailContent}
          />

          <AddCompanyModal
            moduleName="lead"
            selectedIds={selectedLeadIds}
            afterModalClose={afterModalActionClose}
            onModalClose={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <LeadDisablePopup
            selectedLeadIds={selectedLeadIds}
            showDeleteOffcanvas={showDeleteOffcanvas}
            onPopupClose={() => {
              setShowDeleteOffcanvas(false);
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
            selectedLeadNames={selectedLeadNames}
            selectedLeadEmails={selectedLeadEmails}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            reloadLeadList={afterDeleteLeads}
          />

          <ScheduleAutomationPopup
            selectedLeads={leadsDataList.filter((lead) =>
              selectedLeadIds.includes(lead._id),
            )}
            module="lead"
            onClose={() => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
            }}
            onSuccess={(data) => {
              setSelectedLeadIds([]);
              setRowSelection({});
              setSelectedLeadNames([]);
              setSelectedLeadEmails("");
              // Optionally refresh the lead list if needed
              // setReloadData(true);
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <CrmLeadAllowFieldsBySector
            moduleSlug="MOD_LEAD"
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default CRMLeadListBody;
